export function ChevronDown({ className = "w-2" }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 56 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m28 .828-2.656 2.313-25 22 5.312 6.03L28 11.517l22.344 19.656 5.312-6.031-25-22L28 .828Z"
        fill="currentColor"
      />
    </svg>
  );
}
